// extracted by mini-css-extract-plugin
module.exports = {"BooksSelect":"BooksSelect_BooksSelect__Ww2Av","isSelected":"BooksSelect_isSelected__318XZ","BooksSelect__Placeholder":"BooksSelect_BooksSelect__Placeholder__nQDzI"};